<template>
  <section class="document-create">
    <header>
      <mo-pageheader>
        <template slot="title">{{ $t('title.documentCreate') }}</template>
        <template slot="action">
          <div class="buttons-container flex flex-end">
            <ba-button type="button" class="primary" @click.native="$router.go(-1)">{{ $t('action.cancel') }}</ba-button>
            <ba-button class="primary" @click.native="handleCreateDocument" :disabled="isCreationOngoing">{{ $t('action.save') }}</ba-button>
          </div>
        </template>
      </mo-pageheader>
    </header>

    <main>
      <form @submit.prevent="handleCreateDocument">
        <!-- AAA section -->
        <ba-card>
          <template slot="header">
            <span>{{ $t('sectionTitle.informationAaa') }}</span>
          </template>
          <template>
            <div class="cols">
              <div class="col-4">
                <ba-dropdown-input
                  ref="aaa_energy"
                  label="Energie"
                  :keys="['name']"
                  :options="energies"
                  property="name"
                  v-model="aaa_energy"
                  @change="handleCreateNewEnergy('aaa')"
                  @input="selectEnergy('aaa_energy')"
                  @create:new="handleCreateNewEnergy('aaa')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="gearbox"
                  label="Type boîte"
                  :keys="['label']"
                  :options="gearboxes"
                  property="label"
                  v-model="gearbox"
                  @change="handleCreateNewGearbox"
                  @input="selectGearbox"
                  @create:new="handleCreateNewGearbox"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre cylindres" v-model="aaa_cylinder_number"></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Moteur turbo" v-model="turbocharger"></ba-input>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="aaa_brand"
                  label="Marque"
                  :keys="['name']"
                  :options="brands"
                  property="name"
                  v-model="aaa_brand"
                  @change="handleCreateNewBrand('aaa')"
                  @input="selectBrand('aaa_brand')"
                  @create:new="handleCreateNewBrand('aaa')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Cylindré" v-model="aaa_cylinder"></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre de vitesse" v-model="gear_number"></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Mode injection" v-model="injection_mode"></ba-input>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="aaa_model"
                  label="Modèle"
                  :keys="['name']"
                  :options="SearchInput.aaa_model_opt"
                  property="name"
                  v-model="aaa_model"
                  @change="handleCreateNewModel('aaa')"
                  @input="selectModel('aaa_model')"
                  @create:new="handleCreateNewModel('aaa')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre soupape" v-model="valve_number"></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Carrosserie" v-model="carbody"></ba-input>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="aaa_version"
                  label="Version"
                  :keys="['name']"
                  :options="SearchInput.aaa_version_opt"
                  property="name"
                  v-model="version"
                  @change="handleCreateNewVersion('aaa')"
                  @input="selectVersion('aaa')"
                  @create:new="handleCreateNewVersion('aaa')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Puissance CV" v-model="aaa_steam_power"></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Type propulsion" v-model="propulsion"></ba-input>
              </div>
            </div>
          </template>
        </ba-card>

        <!-- Tecdoc section -->
        <ba-card>
          <template slot="header">
            <span>{{ $t('sectionTitle.informationTecdoc') }}</span>
          </template>
          <template>
            <div class="cols">
              <div class="col-4">
                <ba-input type="text" label="Ktype" v-model="ktype"></ba-input>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="tecdoc_energy"
                  label="Energie"
                  :keys="['name']"
                  :options="energies"
                  property="name"
                  v-model="tecdoc_energy"
                  @change="handleCreateNewEnergy('tecdoc')"
                  @input="selectEnergy('tecdoc_energy')"
                  @create:new="handleCreateNewEnergy('tecdoc')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <section class="basic-date">
                  <label>{{ $t('text.dateMin') }}</label>
                  <datepicker
                    label="Date min"
                    type="date"
                    name="date"
                    format="01/MM/yyyy"
                    class="basic-datepicker"
                    :minimum-view="'month'"
                    :maximum-view="'month'"
                    :language="language"
                    v-model="date_min"
                  >
                  </datepicker>
                </section>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="tecdoc_brand"
                  label="Marque"
                  :keys="['name']"
                  :options="brands"
                  property="name"
                  v-model="tecdoc_brand"
                  @change="handleCreateNewBrand('tecdoc')"
                  @input="selectBrand('tecdoc_brand')"
                  @create:new="handleCreateNewBrand('tecdoc')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Cylindré" v-model="tecdoc_cylinder"></ba-input>
              </div>
              <div class="col-4">
                <section class="basic-date">
                  <label>{{ $t('text.dateMax') }}</label>
                  <datepicker
                    label="Date max"
                    type="date"
                    name="date"
                    format="01/MM/yyyy"
                    class="basic-datepicker"
                    :minimum-view="'month'"
                    :maximum-view="'month'"
                    :language="language"
                    v-model="date_max"
                  >
                  </datepicker>
                </section>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="tecdoc_model"
                  label="Modèle"
                  :keys="['name']"
                  :options="SearchInput.tecdoc_model_opt"
                  property="name"
                  v-model="tecdoc_model"
                  @change="handleCreateNewModel('tecdoc')"
                  @input="selectModel('tecdoc_model')"
                  @create:new="handleCreateNewModel('tecdoc')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre cylindres" v-model="tecdoc_cylinder_number"></ba-input>
              </div>
              <div class="col-4">
                <ba-dropdown-input
                  ref="tecdoc_version"
                  label="Type"
                  :keys="['name']"
                  :options="SearchInput.tecdoc_version_opt"
                  property="name"
                  v-model="type"
                  @change="handleCreateNewVersion('tecdoc')"
                  @input="selectVersion('tecdoc')"
                  @create:new="handleCreateNewVersion('tecdoc')"
                >
                </ba-dropdown-input>
              </div>
              <div class="col-4">
                <!-- <ba-input type="text" label="Type" v-model="type"></ba-input> -->
                <ba-input type="text" label="Puissance CV" v-model="tecdoc_steam_power"></ba-input>
              </div>
            </div>
          </template>
        </ba-card>

        <!-- Cnit list / motor & gearbox section -->
        <div class="cards-container flex-stretch flex-space">
          <ba-card class="cnit-mine-card">
            <template slot="header">
              <span>{{ $t('sectionTitle.cnitMine') }}</span>
            </template>
            <template>
              <div class="cnit-mine-ctn">
                <div class="cnit-list">
                  <table>
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Immatriculation</th>
                        <th>Label</th>
                        <th>VIN</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cnit in cnit_list">
                        <td class="type">Cnit</td>
                        <td class="matriculation">{{cnit.matriculation}}</td>
                        <td class="label">{{cnit.label}}</td>
                        <td class="VIN">{{cnit.vin}}</td>
                        <td>
                          <span v-if="!cnit.is_valid" class="icon" @click="handleValidateCnit(cnit)"><ab-icon icon="checkmark"></ab-icon></span>
                          <span v-if="!cnit.is_valid" class="icon" @click="$modal.show('remove-cnit-mine', { id: cnit.id, label: cnit.label, type: 'cnit' })"><ab-icon icon="bin"></ab-icon></span>
                        </td>
                      </tr>
                      <tr v-for="mine in mine_list">
                        <td class="type">Mine</td>
                        <td class="matriculation">{{mine.matriculation}}</td>
                        <td class="label">{{mine.label}}</td>
                        <td class="VIN">{{mine.vin}}</td>
                        <td>
                          <span v-if="!mine.is_valid" class="icon" @click="handleValidateMine(mine)"><ab-icon icon="checkmark"></ab-icon></span>
                          <span v-if="!mine.is_valid" class="icon" @click="$modal.show('remove-cnit-mine', { id: mine.id, label: mine.label, type: 'mine' })"><ab-icon icon="bin"></ab-icon></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- New cnit/mine section -->
                <div class="flex new-cnit">
                  <ba-select class="type" label="Type" :allow-empty="false" v-model="newCnit.type">
                    <option value="cnit">Cnit</option>
                    <option value="mine">Mine</option>
                  </ba-select>
                  <ba-input class="matriculation" type="text" label="Immatriculation" v-model="newCnit.matriculation"></ba-input>
                  <ba-input class="label" type="text" label="Label" v-model="newCnit.label"></ba-input>
                  <ba-input class="label" type="text" label="VIN" v-model="newCnit.vin"></ba-input>
                  <ba-button type="button" class="primary" @click.native="handleAddCnitMine">+</ba-button>
                </div>
              </div>
            </template>
          </ba-card>
          <ba-card class="observation-card">
            <template slot="header">
              <span>{{ $t('sectionTitle.motorOrigin') }}</span>
            </template>
            <template>
              <div class="container">
                <ba-input type="text" label="Type moteur" v-model="motor_type"></ba-input>
                <ba-input type="text" label="Adaptabilité moteur" v-model="motor_adaptability"></ba-input>
                <ba-textarea class="observation" label="Observation" v-model="motor_observation"></ba-textarea>
              </div>
            </template>
          </ba-card>
          <ba-card class="observation-card">
            <template slot="header">
              <span>{{ $t('sectionTitle.gearboxOrigin') }}</span>
            </template>
            <template>
              <div class="container">
                <ba-input type="text" label="Type boîte" v-model="gearbox_type"></ba-input>
                <ba-input type="text" label="Adaptabilité boîte" v-model="gearbox_adaptability"></ba-input>
                <ba-textarea class="observation" label="Observation" v-model="gearbox_observation"></ba-textarea>
              </div>
            </template>
          </ba-card>
        </div>

        <!-- Buttons section -->
        <div class="buttons-container flex flex-end">
          <ba-button type="button" class="primary" @click.native="$router.go(-1)">{{ $t('action.cancel') }}</ba-button>
          <ba-button class="primary" :disabled="isCreationOngoing">{{ $t('action.save') }}</ba-button>
        </div>
      </form>
    </main>

  </section>
</template>

<script>
import { mapState } from 'vuex';
import { BaButton, BaCard, BaDropdownInput, BaInput, BaSelect, BaTextarea } from '@ab/basic-components';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';

import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';


export default {
  name: 'DocumentCreate',
  components: {
    BaButton,
    BaCard,
    BaDropdownInput,
    BaInput,
    BaSelect,
    BaTextarea,
    Datepicker,
    MoPageheader
  },
  mounted() {
    this.$store.dispatch('getBrands');
    this.$store.dispatch('getEnergies');
    this.$store.dispatch('getGearboxes');

    this.$store.commit('setSpinner', false);
  },
  data() {
    return {
      aaa_brand: '',
      aaa_cylinder: '',
      aaa_cylinder_number: '',
      aaa_energy: '',
      aaa_model: '',
      aaa_steam_power: '',
      carbody: '',
      cnit_list: [],
      date_max: '',
      date_min: '',
      gearbox: '',
      gearbox_type: '',
      gearbox_adaptability: '',
      gearbox_observation: '',
      gear_number: '',
      injection_mode: '',
      ktype: '',
      language: fr,
      mine_list: [],
      motor_type: '',
      motor_adaptability: '',
      motor_observation: '',
      propulsion: '',
      tecdoc_energy: '',
      tecdoc_brand: '',
      tecdoc_cylinder: '',
      tecdoc_cylinder_number: '',
      tecdoc_model: '',
      tecdoc_steam_power: '',
      type: '',
      turbocharger: '',
      valve_number: '',
      version: '',
      SearchInput: {
        aaa_brand: '',
        aaa_energy: '',
        aaa_model: '',
        tecdoc_brand: '',
        tecdoc_energy: '',
        tecdoc_model: '',
        gearbox: '',
        aaa_model_opt: [],
        tecdoc_model_opt: [],
        aaa_version_opt: [],
        tecdoc_version_opt: []
      },
      newCnit: {
        label: '',
        matriculation: '',
        type: '',
        vin: ''
      },
      isCreationOngoing: false,
    };
  },
  computed: {
    ...mapState({ brands: state => state.parts.brands }),
    ...mapState({ energies: state => state.documents.energies }),
    ...mapState({ gearboxes: state => state.parts.gearboxes }),
    ...mapState({ models: state => state.parts.models }),
    ...mapState({ versions: state => state.parts.versions }),
  },
  methods: {
    // Energy
    selectEnergy(data) {
      // Store 'energy' data with brand name
      this.SearchInput[data] = this.energies.find(e => e.id == this[data]).name;
    },
    handleCreateNewEnergy(flag) {
      if (flag == 'aaa') {
        this.aaa_energy = '';
        this.SearchInput.aaa_energy = this.$refs.aaa_energy.computedValue;
      }
      if (flag == 'tecdoc') {
        this.tecdoc_energy = '';
        this.SearchInput.tecdoc_energy = this.$refs.tecdoc_energy.computedValue;
      }
    },
    // Brand
    async selectBrand(data) {
      // Call models related to brand
      await this.$store.dispatch('getModels', this[data]);
      if (data.includes('aaa')) {
        this.$refs.aaa_model.reset();
        this.aaa_model = '';
        this.$refs.aaa_version.reset();
        this.version = '';
        this.SearchInput.aaa_version_opt = [];
        this.SearchInput.aaa_model_opt = this.models;
      }
      if (data.includes('tecdoc')) {
        this.$refs.tecdoc_model.reset();
        this.tecdoc_model = '';
        this.SearchInput.tecdoc_version_opt = [];
        this.SearchInput.tecdoc_model_opt = this.models;
      }

      // Store 'brand' data with brand name
      this.SearchInput[data] = this.brands.find(e => e.id == this[data]).name;
    },
    handleCreateNewBrand(flag) {
      if (flag == 'aaa') {
        this.aaa_brand = '';
        this.SearchInput.aaa_brand = this.$refs.aaa_brand.computedValue;
      }
      if (flag == 'tecdoc') {
        this.tecdoc_brand = '';
        this.SearchInput.tecdoc_brand = this.$refs.tecdoc_brand.computedValue;
      }
    },
    // Model
    async selectModel(data) {
      await this.$store.dispatch('getVersions', this[data]);
      if (data.includes('aaa')) {
        this.SearchInput.aaa_model = this.SearchInput.aaa_model_opt.find(e => e.id == this.aaa_model).name;
        this.$refs.aaa_version.reset();
        this.version = '';
        this.SearchInput.aaa_version_opt = this.versions;
      }
      if (data.includes('tecdoc')) {
        this.SearchInput.tecdoc_model = this.SearchInput.tecdoc_model_opt.find(e => e.id == this.tecdoc_model).name;
        this.$refs.tecdoc_version.reset();
        this.type = '';
        this.SearchInput.tecdoc_version_opt = this.versions;
      }
    },
    handleCreateNewModel(flag) {
      if (flag == 'aaa') {
        this.aaa_model = '';
        this.SearchInput.aaa_model = this.$refs.aaa_model.computedValue;
      }
      if (flag == 'tecdoc') {
        this.tecdoc_model = '';
        this.SearchInput.tecdoc_model = this.$refs.tecdoc_model.computedValue;
      }
    },
    // Gearbox
    selectGearbox() {
      this.SearchInput.gearbox = this.gearboxes.find(e => e.id == this.gearbox).label;
    },
    handleCreateNewGearbox() {
      this.gearbox = '';
      this.SearchInput.gearbox = this.$refs.gearbox.computedValue;
    },
    // Version
    selectVersion(flag) {
      if (flag == 'aaa') {
        this.SearchInput.aaa_version = this.SearchInput.aaa_version_opt.find(e => e.id == this.version).name;
      }
      if (flag == 'tecdoc') {
        this.SearchInput.tecdoc_version = this.SearchInput.tecdoc_version_opt.find(e => e.id == this.type).name;
      }
    },
    handleCreateNewVersion(flag) {
      if (flag == 'aaa') {
        this.version = '';
        this.SearchInput.aaa_version = this.$refs.aaa_version.computedValue;
      }
      if (flag == 'tecdoc') {
        this.type = '';
        this.SearchInput.tecdoc_version = this.$refs.tecdoc_version.computedValue;
      }
    },
    // Cnit/Mine
    handleAddCnitMine() {
      if (!this.newCnit.type || !this.newCnit.matriculation || !this.newCnit.label) {
        return this.$store.dispatch('displaySnackbar', { text: "Veuillez remplir tous les champs préalables à la création d'un nouveau Cnit/Type MINE", mode: 'error' });
      }

      // push Cnit or Mine
      if (this.newCnit.type == 'cnit') {
        this.cnit_list.push({
          is_valid: true,
          label: this.newCnit.label,
          matriculation: this.newCnit.matriculation,
          vin: this.newCnit.vin
        });
      } else {
         this.mine_list.push({
          is_valid: true,
          label: this.newCnit.label,
          matriculation: this.newCnit.matriculation,
          vin: this.newCnit.vin
        });
      }

      // Reset newCnit input
      this.newCnit.type = '';
      this.newCnit.matriculation = '';
      this.newCnit.label = '';
      this.newCnit.vin = '';
      return;
    },
    async handleCreateDocument() {
      const gearboxType = this.gearbox_type.split(',');
      const gearboxAdaptability = this.gearbox_adaptability.split(',');
      const motorType = this.motor_type.split(',');
      const motorAdaptability = this.motor_adaptability.split(',');

      const dateMin = this.date_min ? this.date_min.getTime() : null;
      const dateMax = this.date_max ? this.date_max.getTime() : null;

      if (dateMin && dateMax && dateMin > dateMax) {
        this.$store.dispatch('displaySnackbar', { text: 'La date min doit être antérieure à la date max', mode: 'error' });
        return;
      }

      // Disabled button during process
      this.$store.commit('setSpinner', true);
      this.isCreationOngoing = true;

      const data = await this.$store.dispatch('createDocument', {
        aaa_brand: this.SearchInput.aaa_brand,
        aaa_carbody: this.carbody,
        aaa_cylinder: Number(this.aaa_cylinder),
        aaa_cylinder_number: Number(this.aaa_cylinder_number),
        aaa_energy: this.SearchInput.aaa_energy,
        aaa_gearbox: this.SearchInput.gearbox,
        aaa_gear_number: Number(this.gear_number),
        aaa_injection_mode: this.injection_mode,
        aaa_ktype: this.ktype,
        aaa_model: this.SearchInput.aaa_model,
        aaa_propulsion: this.propulsion,
        aaa_steam_power: Number(this.aaa_steam_power),
        aaa_turbocharger: this.turbocharger,
        aaa_valve_number: Number(this.valve_number),
        aaa_version: this.SearchInput.aaa_version,
        cnit_list: this.cnit_list,
        gearbox_adaptability: gearboxAdaptability.map(e => e.trim()),
        gearbox_observation: this.gearbox_observation,
        gearbox_type: gearboxType.map(e => e.trim()),
        mine_list: this.mine_list,
        motor_adaptability: motorAdaptability.map(e => e.trim()),
        motor_observation: this.motor_observation,
        motor_type: motorType.map(e => e.trim()),
        tecdoc_brand: this.SearchInput.tecdoc_brand,
        tecdoc_cylinder: Number(this.tecdoc_cylinder),
        tecdoc_cylinder_number: Number(this.tecdoc_cylinder_number),
        tecdoc_date_max: dateMax,
        tecdoc_date_min: dateMin,
        tecdoc_energy: this.SearchInput.tecdoc_energy,
        tecdoc_model: this.SearchInput.tecdoc_model,
        tecdoc_steam_power: Number(this.tecdoc_steam_power),
        tecdoc_version: this.SearchInput.tecdoc_version,
      });
      this.$store.commit('setSpinner', false);
      this.isCreationOngoing = false;
      if (data) {
        this.$store.dispatch('displaySnackbar', { text: 'La fiche article a bien été créée' });
        this.$router.push({ name: 'DocumentList' });
      }
    }
  }
};
</script>

<style src="@/assets/styles/documents.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
<style src="@/assets/styles/modals.css"></style>
